import React from 'react';
import Loadable from 'react-loadable';

import { Loader } from '@topconagriculture/loader';

import { RoutesConfiguration } from '../../../store/router/router.types';

export enum accessDeniedRoutesPaths {
  accessDeniedRoot = '/access-denied',
}

const AccessDeniedPage = Loadable({
  loader: () => import('./AccessDeniedPage/AccessDeniedPage'),
  loading: () => <Loader />,
});

export const accessDeniedRoutesConfig: RoutesConfiguration = {
  shared: [
    {
      path: accessDeniedRoutesPaths.accessDeniedRoot,
      component: AccessDeniedPage,
    },
  ],
};
